import { observable, action, computed } from 'mobx';
import { ProductSku, IProductSkuMap } from '../domain/entities/ProductSku';
import { Config } from '../../internal/domain/entities/Config';
import { ISku } from '../domain/entities/Sku';
import { ProdcatApiSdk } from '~api/ProdcatApiSdk';
import { ICoreProduct } from '~api/interfaces/IProduct';
import { IParamsById } from '~api/interfaces/IParamsById';

export interface IProductSkuRepository {
    prodcatApiSdk: ProdcatApiSdk;
    config: Config;
}

export class ProductSkuRepository {
    @observable public productData: ICoreProduct[];

    private prodcatApiSdk: ProdcatApiSdk;
    private config: Config;

    constructor(productSkuStoreConfig: IProductSkuRepository) {
        this.prodcatApiSdk = productSkuStoreConfig.prodcatApiSdk;
        this.config = productSkuStoreConfig.config;
    }

    @action
    public clearStore = () => {
        this.productData = [];
    };

    @action
    public setProductData = (data: ICoreProduct[]) => {
        this.productData = data;
    };

    @computed
    public get products(): IProductSkuMap {
        return this.productData && this.productData.reduce(this.mapProductDataById, {});
    }

    public getProductData = async (
        paramsById: IParamsById,
        query?: string
    ): Promise<IProductSkuMap> => {
        try {
            const products = await this.prodcatApiSdk.getProducts(paramsById, query);
            this.setProductData(products);
        } catch (error) {
            this.setProductData([]);
        }

        return this.products;
    };

    private mapProductDataById = (data: IProductSkuMap, product: ICoreProduct) => {
        const getProducts = (skuData: IProductSkuMap, sku: ISku) => {
            const { skus, ...productDetails } = product;
            const newSku = {
                ...productDetails,
                ...sku
            };

            return {
                ...skuData,
                [sku.sku_id]: ProductSku.fromJSON(newSku, this.config.config.currency)
            };
        };

        const skusData = product.skus.items.reduce(getProducts, {});

        return { ...data, ...skusData };
    };
}
